import { Tag } from '@servicetitan/design-system';

interface UrgentFollowUpsBadgeProps {
  id: string;
  badgeTitle: string;
  useCountQuery: () => {
    error?: Error;
    previousCount: number | undefined;
    currentCount: number | undefined;
  };
}

const UrgentFollowUpsBadge = ({
  id,
  badgeTitle,
  useCountQuery,
}: UrgentFollowUpsBadgeProps) => {
  const count = useCountQuery();

  let badgeText: number | string | undefined =
    count.currentCount ??
    // Fall back to any previous fetch's count. This prevents flickering when
    // we render during a slow load.
    count.previousCount;

  if (count.error) {
    badgeText = '?';
    badgeTitle = `Error fetching: ${badgeTitle}`;
  }

  return (
    !!badgeText && (
      <Tag
        badge
        compact
        style={{
          marginLeft: 'auto',
        }}
        id={id}
        color='critical'
        title={badgeTitle}
      >
        {badgeText}
      </Tag>
    )
  );
};

export default UrgentFollowUpsBadge;
